import Admin from "./Admin";
import RevokeAdmin from "./RevokeAdmin";
import AddAdmin from "./AddAdmin";
import EditAdmin from "./EditAdmin";
import PermissionList from "./PermissionList";

export {
    Admin,
    RevokeAdmin,
    AddAdmin,
    EditAdmin,
    PermissionList,
}